module.exports = __webpack_public_path__ + "img/docbanner1.e47522ab.png";